<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/I58Eue/tc-custom/9781614234425.jpg?1701060574142" alt="This image is the cover for the book Haunted Marietta, Haunted America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haunted Marietta, Haunted America
      </h1>
      <p class="bookDescription body article font2">
        <b>“Highlight[s] the numerous spirits which inhabit this charming Georgia town, while also offering a glimpse into the town's non-paranormal past” (<i>Newswire</i>).</b><br/>  <br/> Few places have continued to grow, prosper, and maintain a small-town atmosphere and sense of history like Marietta, Georgia. Of course, a sense of community is not the only preserved presence from the past. Paranormal specialist and Marietta resident Rhetta Akamatsu combines her research with a passion for history to deliver a one-of-a-kind glimpse into the area's rich and, in some cases, undying spirit. Hear the whispers of Confederate generals still echoing in the Kolb Farm House; cozy up with the unsettled spirits of the 1848 House; meet the phantoms lurking throughout Town Square; and brush up on your local history if you dare summon the Ghosts of Marietta.<br/>  <br/> Includes photos!<br/>  <br/> “In her book, Akamatsu isn’t content to delve immediately into the paranormal, but is respectful enough of her adopted home to explore some of Marietta’s stately history first.” —<i>The Atlanta Journal-Constitution</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rhetta Akamatsu
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Haunted America
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7ae86e94